import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: number | string, currency: string = 'kr'): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(numValue)) {
      return '-';
    }

    // Format to 2 decimal places first
    const formatted = numValue.toFixed(2);
    
    // Remove .00 but keep other decimals like .15, .50, etc.
    const cleanFormatted = formatted.replace(/\.00$/, '');
    
    return `${cleanFormatted} ${currency}`;
  }
}
